import { render } from "./ListeCorrectionRequestPage.vue?vue&type=template&id=85d8bea2&ts=true"
import script from "./ListeCorrectionRequestPage.vue?vue&type=script&lang=ts"
export * from "./ListeCorrectionRequestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__